import { ref } from 'vue'
import liff from '@line/liff'

export type LiffAuthState = {
  ready: boolean
  loggedIn: boolean
  idToken?: string
  accessToken?: string
  userId?: string
  displayName?: string
  pictureUrl?: string
}

const state = ref<LiffAuthState>({
  ready: false,
  loggedIn: false,
})

let _initPromise: Promise<LiffAuthState> | null = null

export function useLiffAuth() {
  async function initAndRequireLogin() {
    if (_initPromise) return _initPromise

    _initPromise = (async () => {
      const liffId = import.meta.env.VITE_LIFF_ID as string | undefined
      if (!liffId) throw new Error('VITE_LIFF_ID is missing')

      await liff.init({ liffId })

      // 未登入：直接導去登入（會回到 redirectUri）
      if (!liff.isLoggedIn()) {
        liff.login({ redirectUri: window.location.href })
        // 這行理論上不會跑到（因為會跳轉）
        return { ready: false, loggedIn: false }
      }

      // 已登入：拿 token / profile
      const idToken = liff.getIDToken() ?? undefined
      const accessToken = liff.getAccessToken() ?? undefined

      // 取 profile 需在 LINE app 或 LIFF browser context 才穩（但大多 OK）
      let profile: any = null
      try {
        profile = await liff.getProfile()
      } catch {
        // 某些環境可能拿不到 profile，但 token 還是可用
      }

      state.value = {
        ready: true,
        loggedIn: true,
        idToken,
        accessToken,
        userId: profile?.userId,
        displayName: profile?.displayName,
        pictureUrl: profile?.pictureUrl,
      }
      return state.value
    })()

    return _initPromise
  }

  function logout() {
    if (liff.isLoggedIn()) liff.logout()
    // 登出後回首頁或登入頁（避免留在需要權限的頁）
    window.location.href = window.location.origin
  }

  return {
    state,
    initAndRequireLogin,
    logout,
  }
}
